export default function callbackResponse({ main, on, elm, state, subscribe }) {
	const dialog = elm.closest('dialog');

	main(_ => {
		subscribe('callback-form:response', open);
	});

	const open = function (result) {
		state.set(s => {
			s.title = result.title;
			s.message = result.message;
		});

		dialog.showModal();
	}
};

export const model = {
	title: '',
	message: '',
};
